// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';

import { Swiper as SwiperClass } from 'swiper/types';

import { MainBannerData } from '../../interfaces/MainSection.interface';
import { MAIN_BANNER_SWIPER_AUTOPLAY } from '../../main.config';
import applyImageUrlFormat from '../../../shared/utils/image/imaegUrlformatter';

interface Props {
  banners: MainBannerData[];
  onSwiper?(swiper: SwiperClass): void;
  onSelectBanner(index: number, bannerId: number): void;
}

export default function MainBannerSwiper({ banners, onSwiper, onSelectBanner }: Props) {
  return (
    <Swiper
      onSwiper={onSwiper}
      modules={[Autoplay]}
      autoplay={MAIN_BANNER_SWIPER_AUTOPLAY}
      loop
    >
      {banners.map(({ id: bannerId, link, imageUrl }, index) => (
        <SwiperSlide
          key={bannerId}
          style={{
            cursor: 'pointer',
          }}
        >
          <a href={link}
            onClick={() => onSelectBanner(index, bannerId)}
          >
            <img
              className="main-banner-image"
              src={applyImageUrlFormat(imageUrl, { format: 'auto' })}
              alt={`main-banner-${bannerId}`}
            />
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
